import { Inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalAlertComponent } from '../components/modal-alert/modal-alert.component';

import { ModalSignatoryComponent } from '../components/modal-signatory/modal-signatory.component';

import { firstValueFrom } from 'rxjs';
import { Icons } from '../components/modal-alert/enums';
import { WINDOW } from '../utils/window';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private dialog: MatDialog, @Inject(WINDOW) private window: Window) { }

  openAlert(data: Object, disableClose: boolean) {

    let width = '100%'
    const screen = this.window.screen.width;

    if( screen > 1400 ){
      width = '40%';
    }else if( screen > 992 ){
      width = '50%';
    }

    return this.dialog.open(ModalAlertComponent, {
      data,
      disableClose,
      width
    });
  }

  openAlertSelectSignatorys(data: Object, disableClose: boolean) {
    return this.dialog.open(ModalSignatoryComponent, {
      data,
      disableClose,
    });
  }

  showAlertWithoutIds(
    msg: string,
    icon: Icons,
    isQuestion: boolean = false,
    title: string = ''
  ) {
    const props = {
      title: title,
      content: msg,
      btnAction1: isQuestion ? 'Confirmar' : 'Entendido',
      btnAction2: isQuestion ? 'Cancelar' : '',
      icon: icon,
      idBtnAction1: null,
      idBtnAction2: null,
    };

    return firstValueFrom(this.openAlert(props, true).afterClosed());
  }

  showAlertWithIds(
    msg: string,
    icon: Icons,
    idBtnAction1: string,
    idBtnAction2: string,
    isQuestion: boolean = false,
    title: string = ''
  ) {
    const props = {
      title: title,
      content: msg,
      btnAction1: isQuestion ? 'Confirmar' : 'Entendido',
      btnAction2: isQuestion ? 'Cancelar' : '',
      icon: icon,
      idBtnAction1: idBtnAction1,
      idBtnAction2: idBtnAction2,
    };

    return firstValueFrom(this.openAlert(props, true).afterClosed());
  }

  openAlertNotLogged() {

    const props = {
      title: 'Lo sentimos..',
      content: 'Tu sesión expiró, vuelve a inciar sesión para continuar',
      btnAction1: 'Iniciar Sesión',
      btnAction2: 'Cancelar',
      icon: Icons.info,
      idBtnAction1: null,
      idBtnAction2: null
    };

    return firstValueFrom(this.openAlert(props, true).afterClosed());

  }

}
